import React, { createContext } from 'react'
import { showToast } from '@/components/Toast/toast-provider'

export interface Toast {
  type: 'danger' | 'success' | 'warning'
  title?: string
  skipScroll?: boolean
  subtitle?: string
  dangerouslySetInnerHTML?: { __html: string }
  url?: string
  onClick?: () => void
  requireInteraction?: boolean
}
export const ToastContext = createContext<(toast?: Toast) => void>(() => {})
export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <ToastContext.Provider value={showToast}>{children}</ToastContext.Provider>
}
const toastWithOptions = (titleOrOptions: string | Partial<Toast>, moreOptions: Toast): Toast => {
  const base = typeof titleOrOptions === 'string' ? { title: titleOrOptions } : titleOrOptions
  return { ...base, ...moreOptions }
}

export const errorToast = (titleOrOptions: string | Partial<Toast>): Toast =>
  toastWithOptions(titleOrOptions, { type: 'danger' })

export const successToast = (titleOrOptions: string | Partial<Toast>): Toast =>
  toastWithOptions(titleOrOptions, { type: 'success' })

export const infoToast = (titleOrOptions: string | Partial<Toast>): Toast =>
  toastWithOptions(titleOrOptions, { type: 'warning' })
